// extracted by mini-css-extract-plugin
export default {"dialog_content":"desnsitzeConfirm_dialog_content__YfGY8"};